import { useUserStore } from '@/stores/user'
import { useUserMetricsStore } from '@/stores/userMetrics'
import { useAppStore } from '@/stores/app'
import { usePaywallGuard } from '@/composables/usePaywallGuard'

export const useModalsStore = defineStore('modals', () => {
  const userStore = useUserStore()
  const userMetricsStore = useUserMetricsStore()
  const appStore = useAppStore()

  const showSpecialtyModelModal = ref(false)
  const showShareTabGuideModal = ref(false)
  const showCompleteProfileModal = ref(false)
  const fromOriginProfileModal = ref(null) // from where the profile modal was opened
  const showCustomTemplateModal = ref(false)
  const showCompleteProfileCTAModal = ref(false)
  const showResourceUseLimitModal = ref(false)
  const showWellcomeProModal = ref(false)
  const showedWellcomeProModal = ref(false)
  const showCompletedProfileModal = ref(false)

  const token = window.tokenParsed

  //get showedWellcomeProModal from localstorage if exists
  showedWellcomeProModal.value =
    JSON.parse(
      localStorage.getItem(`showed-wellcome-pro-modal-${token?.sub}`),
    ) ?? showedWellcomeProModal.value

  const openCustomTemplateModal = async (origin = null) => {
    if (!userStore.isProfileCompleted && !userStore.isProUser) {
      fromOriginProfileModal.value = origin
      showCompleteProfileModal.value = true
      return false
    }

    await Promise.all([
      userMetricsStore.refetchUserMetrics(),
      appStore.refetchCustomPromptList(),
    ])

    const {
      blockIfResourceLimitReached,
      blockIfCustomPromptCreationNotAllowed,
    } = usePaywallGuard()

    if (blockIfResourceLimitReached()) return false
    if (blockIfCustomPromptCreationNotAllowed()) return false

    showCustomTemplateModal.value = true
    return true
  }

  const setShowedWellcomeProModal = () => {
    showedWellcomeProModal.value = true
    localStorage.setItem(
      `showed-wellcome-pro-modal-${token?.sub}`,
      showedWellcomeProModal.value,
    )
  }

  const openCompleteProfileFromEvidence = () => {
    fromOriginProfileModal.value = 'evidence'
    showCompleteProfileModal.value = true
  }

  return {
    showSpecialtyModelModal,
    showShareTabGuideModal,
    showCompleteProfileModal,
    fromOriginProfileModal,
    showCustomTemplateModal,
    showCompleteProfileCTAModal,
    showResourceUseLimitModal,
    showWellcomeProModal,
    showedWellcomeProModal,
    showCompletedProfileModal,
    setShowedWellcomeProModal,
    openCustomTemplateModal,
    openCompleteProfileFromEvidence,
  }
})
